import React from 'react';
import { Block } from "@randajan/jet-react/dom/block";
import { varsBeam } from '../../config/bifrost';
import { useBeam } from '@randajan/bifrost/client/react';

import "./Subscriptions.scss";
import { usePop } from '@randajan/jet-react/dom/modal';
import { Subscription } from './Subscription/Subscription';


const variants = [1, 3, 6];

export const Subscriptions = (props) => {
    const { } = props;

    const { data:vars } = useBeam(varsBeam);
    const ppm = vars?.pricePerMonth;

    const pop = usePop();

    return (
        <Block className="Subscriptions" caption="Předplatné">
            <div className="noEur"><span>Prosíme naše zákaznice a zákazníky ze Slovenska o trpělivost v tuto chvíli</span><br/><b>přijímáme platby pouze v CZK</b></div>
            
            <div className="buttons">
                {variants.map((v, k)=><Subscription key={k} pop={pop} monthCount={v} pricePerMonth={ppm}/>)}
            </div>
            <div className="note">Platební brána již brzy</div>
        </Block>
    )
}